



























































































































































































import { Component, Vue } from 'vue-property-decorator'
import {
  BCard,
  BButton,
  BDropdown,
  BDropdownItem,
  BBadge,
  BAvatar,
  BSpinner,
  BRow,
  BCol,
  BFormGroup
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import moment from 'moment'
import { OpportuniteCreateModel, OpportuniteByStatutModel, OpportuniteUpdateStatutModel, ShortOpportunite } from '@/api/models/opportunites/opportunite'
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import ViewOpportunite from '@/views/adherents/opportunites/ViewOpportunite.vue'
import EditOpportuniteQuickModal from './EditOpportuniteQuickModal.vue'
import { Watch } from 'vue-property-decorator'
import { PaginatedList } from '@/api/models/common/paginatedList'
import { DetailsUtilisateur, ShortUtilisateur } from '@/api/models/utilisateurs/utilisateur'
import { Entreprise } from '@/api/models/adherents/adherent'
import SearchableVueSelect from '@/components/selects/SearchableVueSelect.vue'

interface OpportuniteItem {
  id: string
  nom: string
  prenom: string
  entreprise: string
  telephone: string
  email?: string
  priorite?: 'Haute' | 'Moyenne' | 'Basse'
  dateCreation: string
  assignedTo?: string
  statut: string
}

@Component({
  components: {
    BCard,
    BButton,
    BDropdown,
    BDropdownItem,
    BBadge,
    BAvatar,
    draggable,
    BSpinner,
    ViewOpportunite,
    EditOpportuniteQuickModal,
    SearchableVueSelect,
    BRow,
    BCol,
    BFormGroup
  }
})
export default class KanbanOpportunites extends Vue {
  columns: OpportuniteByStatutModel[] = []
  isViewOpportuniteModalActive = false
  selectedOpportuniteId = ''
  isEditModalActive = false
  selectedEditOpportuniteId = ''
  selectedEditEntrepriseId = ''
  pendingStatusChange: {
    id: string
    entrepriseId: string
    newStatus: string
    index: number
  } | null = null

  listNatureOffres: { code: string; libelle: string; }[] = [];
  paginatedListResponsables = new PaginatedList<DetailsUtilisateur>()
  paginatedListEntreprises = new PaginatedList<Entreprise>()

  filterResponsable: string | null = null
  filterNatureOffre: string | null = null
  filterEntreprise: string | null = null

  isLoading = false

  async created() {
    this.isLoading = true
    await this.loadNatureOffre()
    await this.searchOpportunites()
  }

  async onEditModalCancel(opportuniteId: string) {
    const item = this.findItemById(opportuniteId)
    await this.loadOpportunites()
    this.pendingStatusChange = null
    this.selectedEditOpportuniteId = ''
    this.selectedEditEntrepriseId = ''
    if (item) {
      this.$set(item, 'isLoading', false)
    }
  }

  async searchOpportunites() {
    this.isLoading = true
    await this.loadOpportunites()
    this.isLoading = false
  }

  
  @Watch("filterResponsable")
  @Watch("filterNatureOffre")
  @Watch("filterEntreprise")
  async loadOpportunites() {
    await this.$http.myressif.opportunites
      .listByStatut(this.filterResponsable, this.filterNatureOffre, this.filterEntreprise)
      .then((response: OpportuniteByStatutModel[]) => {
        this.columns = response;
      });
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string}[]> {
    var response: {code: string, libelle: string}[] = []
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then((res: {valeur: string}) => {
        response = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };

      return response;
  }

  async loadNatureOffre() {
    this.listNatureOffres = await this.loadParametre('opportunites_nature_offre')
  }

  async loadResponsables(params: any) {
    await this.$http.myressif.utilisateurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        params?.hiddenUser ?? false,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        this.paginatedListResponsables.items = this.paginatedListResponsables!.items.concat(
          response.items.filter(
            (ri) => !this.paginatedListResponsables!.items.some((lsi) => lsi.id == ri.id)
          )
        ).map((x: ShortUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        this.paginatedListResponsables.hasNextPage = response.hasNextPage
        this.paginatedListResponsables.totalCount = response.totalCount
      })
  }

  async loadEntreprises(params: any) {
    await this.$http.myressif.entreprises
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'libelle',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.pertinentOnly ?? false
      )
      .then((response: PaginatedList<Entreprise>) => {
        this.paginatedListEntreprises.items = this.paginatedListEntreprises!.items.concat(
          response.items.filter(
            (ri) => !this.paginatedListEntreprises!.items.some((lsi) => lsi.id == ri.id)
          )
        );
        this.paginatedListEntreprises.hasNextPage = response.hasNextPage
        this.paginatedListEntreprises.totalCount = response.totalCount
      })
  }

  getLibelleFromCode(code: string | undefined, list: {code: string, libelle: string}[]): string {
    if (!code) return '-'
    const item = list.find(i => i.code === code)
    return item ? item.libelle : code
  }

  onDragChange(event: any, columnId: string) {
    if (event.added || event.moved) {
      const item = event.added ? event.added.element : event.moved.element
      
      this.$set(item, 'isLoading', true)

      var index = 999999;
      if (event.added) {
        index = event.added.newIndex;
      } else if (event.moved) {
        index = event.moved.newIndex;
      }

      if(event.added) {
        this.selectedEditOpportuniteId = item.id
        this.selectedEditEntrepriseId = item.entrepriseId
        this.pendingStatusChange = {
          id: item.id,
          entrepriseId: item.entrepriseId,
          newStatus: columnId,
          index: index
        }
        this.isEditModalActive = true
      } else {
        this.updateOpportuniteStatut(item.id, item.entrepriseId, columnId, index)
      }
    }
  }

  async updateOpportuniteStatut(id: string, entrepriseId: string, newStatus: string, index: number = 0) {
    var data: OpportuniteUpdateStatutModel = {
      statut: newStatus,
      id: id,
      entrepriseId: entrepriseId,
      index: index
    }

    await this.$http.myressif.entreprises
      .updateOpportuniteStatutOnEntreprise(id, entrepriseId, data)
      .then(
        async (response: string) => {
          const item = this.findItemById(id)
          if (item) {
            this.$set(item, 'isLoading', false)
          }
        },
        (error: any) => {
          const item = this.findItemById(id)
          if (item) {
            this.$set(item, 'isLoading', false)
          }
          
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      );
  }

  async saveQuickEdit(opportunite: any) {
    if (!this.pendingStatusChange) return
    const item = this.findItemById(opportunite.id)
    this.$set(item!, 'isLoading', true)

    const { id, entrepriseId, newStatus, index } = this.pendingStatusChange
    opportunite.statut = newStatus
    opportunite.index = index

    await this.$http.myressif.entreprises
      .updateOpportuniteEntreprise(entrepriseId, id, opportunite)
      .then(
        async (response: any) => {
          
          const item = this.findItemById(id)
          if (item) {
            this.$set(item, 'isLoading', false)
          }
        },
        (error: any) => {
          if (item) {
            this.$set(item, 'isLoading', false)
          }
          
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
          
          this.loadOpportunites()
        }
      );

    this.pendingStatusChange = null
    this.selectedEditOpportuniteId = ''
    this.selectedEditEntrepriseId = ''
  }

  findItemById(id: string): ShortOpportunite | null {
    for (const column of this.columns) {
      const item = column.items!.find(i => i.id === id)
      if (item) {
        return item
      }
    }
    return null
  }

  addItem(columnId: string) {
    
  }

  openAddOpportuniteModal() {
  }

  openOpportuniteDetails(item: ShortOpportunite) {
    this.selectedOpportuniteId = item.id
    this.isViewOpportuniteModalActive = true
  }

  getPriorityVariant(priority: string): string {
    const variants: { [key: string]: string } = {
      'Haute': 'danger',
      'Moyenne': 'warning',
      'Basse': 'success'
    }
    return variants[priority] || 'secondary'
  }

  formatMontant(montant: number): string {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(montant)
  }

  resetFilters() {
    this.filterResponsable = null
    this.filterNatureOffre = null
    this.filterEntreprise = null
  }
}
